/* Built In Imports */
import React, { useState } from 'react';

/* External Imports */
import { Box, Flex, Heading } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { IoIosPlayCircle } from 'react-icons/io';
import { MdOutlinePlayCircle } from 'react-icons/md';

/* Internal Imports */
/* Components */
import config from '@config';
import SimpleButton from '@eternal/Components/Buttons/SimpleButton';
import SimpleLink from '@eternal/Components/Buttons/SimpleLink';
import SingleImage from '@eternal/Components/Card/SingleImage';
import MidContainer from '@eternal/Components/Layout/MidContainer';
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';

/* Services */

/**
 *
 * @param {*} sectionContent
 * @returns
 */
const JourneyWithSadhguru = ({ sectionContent, region, lang }) => {
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Box
      width="100%"
      bg="#040404"
      h="auto"
      pos="relative"
      _before={{
        content: "''",
        width: { base: '100%', md: '20%', lg: '15%' },
        height: '100%',
        pos: 'absolute',
        backgroundImage: `${config.imgPath}/d/46272/1725007990-eternalechoes_albumcover_3000x3000-1.png`,
        backgroundSize: 'cover 160%',
        backgroundRepeat: { base: 'no-repeat', md: 'repeat' },
        backgroundPosition: { base: 'left', md: 'center' },
        left: '0',
        top: '0',
        zIndex: 0,
      }}
    >
      <MidContainer w={1240}>
        <Flex
          pos="relative"
          zIndex={1}
          alignItems="center"
          flexWrap="wrap"
          justifyContent="center"
          px={{ base: '5px', md: '20px' }}
        >
          <Box
            flex={1}
            minW="280px"
            pr={{ base: '0', md: '20px' }}
            pb={{ base: '40px', xl: '0' }}
          >
            <Heading
              fontFamily="FedraSerifAStdBook"
              as="h2"
              fontSize={{ base: '26px', md: '26px', lg: '52px' }}
              color="#C9BAAB"
              lineHeight={{ base: '30px', md: '31px', lg: '62px' }}
              fontWeight={300}
              maxW={{ base: 'none', md: 300, lg: '500px' }}
              textTransform="uppercase"
            >
              {findElement('section_title').titleText}
            </Heading>
            <StructuredTextParser
              color="#FFF"
              fontSize={{ base: '16px', md: '14px', lg: '18px' }}
              str={render(sectionContent[2].body)}
              fontFamily="FedraSansStd-book"
              fontWeight="normal"
              maxW={{ base: 'none', md: 300, lg: '368px' }}
              mx="0"
            />
            <Flex
              flexWrap="wrap"
              gap="16px"
              mt={{ base: '30px', md: '45px', lg: '60px' }}
              alignItems="center"
              maxW={{ base: 'none', md: 300, lg: '500px' }}
            >
              <SimpleButton
                mb="0"
                mt="0"
                height="auto"
                style={findElement('simple_button')}
                color="#C9BAAB"
                onMouseEnter={e => {
                  e.preventDefault();
                  setIsHovered(true);
                }}
                onMouseLeave={e => {
                  e.preventDefault();
                  setIsHovered(false);
                }}
                rightIcon={
                  isHovered ? (
                    <IoIosPlayCircle style={{ marginLeft: '5px' }} />
                  ) : (
                    <MdOutlinePlayCircle style={{ marginLeft: '5px' }} />
                  )
                }
              />
              <SimpleLink
                maxH="60px"
                fontSize={{ base: '14px', lg: '18px' }}
                h={{ base: '37px', md: '60px' }}
                textDecoration="underline"
                textAlign="center"
                textTransform="uppercase"
                color="#C9BAAB"
                style={findElement('simple_link')}
                leftM={{ base: '0', md: '25px' }}
              />
            </Flex>
          </Box>
          <Box flex={1} minW="280px">
            <SingleImage
              verticalAlign="middle"
              px="0"
              sync
              maxH={612}
              w="100%"
              sectionContent={findElement('single_image')}
            />
          </Box>
        </Flex>
      </MidContainer>
    </Box>
  );
};

export default JourneyWithSadhguru;
